module.exports = __webpack_public_path__ + "img/piano-keyboard.f1db92b6.svg";